import React, {useState} from 'react'
import {Modal} from 'react-bootstrap'
import {useIntl} from 'react-intl'
import {useDispatch, useSelector} from 'react-redux'
import {useNavigate} from 'react-router-dom'
import {setIsThereNonSavedForm} from '../../../../../common/ModalPopup/reducer'

const ButtonX = () => {
  // const intl = useIntl()
  // const [showCancel, setShowCancel] = useState<boolean>(false)
  // const navigate = useNavigate();
  const isThereNonSavedForm = useSelector((state: any) => state?.isThereNonSavedForm)
  const [showCancel, setShowCancel] = useState<boolean>(false)
  const [w2go, setW2go] = useState<string>('')
  const navigate = useNavigate()
  const intl = useIntl()
  const dispatch = useDispatch()

  const checkEditNonSaved = (e: any, routeName: string) => {
    setW2go(routeName)
    if (isThereNonSavedForm === true) {
      setShowCancel(true)
    } else {
      navigate(routeName, {replace: true})
    }
  }

  const onCancelReset = () => {
    setShowCancel(false)
  }

  const onConfirmCancel = () => {
    setShowCancel(false)
    dispatch(setIsThereNonSavedForm(false))
    navigate(w2go, {replace: true})
  }

  // const onCancel = () => {
  //   setShowCancel(true)
  // }
  // const onResetCancel = () => {
  //   setShowCancel(false)
  // }

  // const onConfirmCancel = () => {
  //   navigate('/home');
  // }

  return (
    <div
      className='p-0 pe-2 d-flex justify-content-end position-absolute '
      style={{right: 0, zIndex: 99, top: -7}}
    >
      <div
        className='d-none d-sm-none d-md-none d-lg-flex d-xl-flex justify-content-end align-items-center btn p-0 px-4'
        onClick={(e) => {
          e.preventDefault()
          checkEditNonSaved(e, '/home')
        }}
        style={{cursor: 'pointer'}}
      >
        <i className='fa-solid fa-xmark text-dark fs-2x '></i>
        <div className='fw-bold d-none d-sm-none d-md-none d-lg-flex d-xl-flex ms-3'>
          {intl.formatMessage({id: 'FINISH'})}
        </div>
      </div>
      <div
        className='d-flex d-sm-flex d-md-flex d-lg-none d-xl-none justify-content-end align-items-center btn p-0'
        onClick={(e) => {
          e.preventDefault()
          checkEditNonSaved(e, '/home')
        }}
        style={{cursor: 'pointer'}}
      >
        <i className='fa-solid fa-xmark text-dark fs-2x '></i>
      </div>
      <Modal show={showCancel} centered>
        <div className='text-center p-5 w-100'>
          <div className='w-100 rounded'>
            <div className='d-flex align-items-center justify-content-between'>
              <div className='fw-bolder text-gray-700 py-3'>
                {intl.formatMessage({id: 'INFORMATION'})}
              </div>
              <div className='p-1 cursor-pointer' onClick={onCancelReset}>
                <i className='fa fa-close text-danger'></i>
              </div>
            </div>
            <div className={'text-start py-3'}>
              <div>{intl.formatMessage({id: 'BEFORE_QUIT_CONFIRM_MESSAGE'})}</div>
            </div>
            <div className='d-flex align-items-center justify-content-evenly'>
              <button className={'btn btn-secondary'} onClick={onCancelReset}>
                {intl.formatMessage({id: 'SWITCH_BACK_TO_INPUT'})}
              </button>
              <button className={'btn btn-primary'} onClick={onConfirmCancel}>
                {intl.formatMessage({id: 'CONTINUE_WITHOUT-SAVING'})}
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </div>
  )
}

export default ButtonX
